import { ICoreResponse } from "@/core/interfaces/coreResponse.interface";
import { StatusCodes } from "http-status-codes";
import DashboardServices from "@/modules/Dashboard/services/dashboard.service";
import { ActionContext, ActionTree } from "vuex";

import { IDashboardState } from "@/core/interfaces/dashboard.interface";
import { GetInsightsDto } from "../dtos/dashboardInsights.dto";
import { StoreState } from "@/store/type";

const actions: ActionTree<IDashboardState, StoreState> = {
  // *********** Agent Insights **************
  async getInsights(
    context: ActionContext<IDashboardState, StoreState>,
    { value, aggregated_by }: GetInsightsDto,
  ) {
    let response: ICoreResponse = {
      success: false,
    };
    try {
      context.commit("setInsightsLoading", true);

      const dashboardServices = new DashboardServices();
      response = await dashboardServices.getInsights(value, aggregated_by);
      if (response.success && response.status === StatusCodes.OK) {
        context.commit("saveInsights", response.data?.data?.graph);
        context.commit(
          "saveBookingAggregate",
          response.data?.data?.booking_aggregate,
        );
      } else {
        throw response;
      }
    } catch (err) {
      console.error("Error in getInsightsData:", err);
    } finally {
      context.commit("setInsightsLoading", false);
    }
  },
  // *********** Daily Flights Bookings and Issuance **************
  async getDailyFlightsIssuanceData(
    context: ActionContext<IDashboardState, StoreState>,
    date: string | null,
  ) {
    let response: ICoreResponse = {
      success: false,
    };
    try {
      context.commit("setInsightsLoading", true);

      const dashboardServices = new DashboardServices();
      response = await dashboardServices.getDailyFlightIssuance(date);
      if (response.success && response.status === StatusCodes.OK) {
        context.commit("saveDailyFlightChart", response.data?.data);
      } else {
        throw response;
      }
    } catch (err) {
      console.error("Error in getDailyFlightsIssuanceData:", err);
    } finally {
      context.commit("setInsightsLoading", false);
    }
  },

  // *********** Daily Hotels Bookings and Issuance **************
  async getDailyHotelsIssuanceData(
    context: ActionContext<IDashboardState, StoreState>,
    date: string | null,
  ) {
    let response: ICoreResponse = {
      success: false,
    };
    try {
      context.commit("setInsightsLoading", true);

      const dashboardServices = new DashboardServices();
      response = await dashboardServices.getDailyHotelIssuance(date);
      if (response.success && response.status === StatusCodes.OK) {
        context.commit("saveDailyHotelChart", response.data?.data);
      } else {
        throw response;
      }
    } catch (err) {
      console.error("Error in getDailyHotelsIssuanceData:", err);
    } finally {
      context.commit("setInsightsLoading", false);
    }
  },
  // *********** Epiry Soon Bookings **************
  async getExpirySoon() {
    let response: ICoreResponse = {
      success: false,
    };
    try {
      const dashboardServices = new DashboardServices();
      response = await dashboardServices.getExpirySoon();
      if (response.success && response.status === StatusCodes.OK) {
        return response.data?.data.count;
        //
      } else {
        throw response;
      }
    } catch (err) {
      console.error("Error in getExpirySoon:", err);
    } finally {
      //
    }
  },
};

export default actions;
